import StarFill from "@/components/common/StarFill";
import { Star, Briefcase, DollarSign } from "lucide-react";

interface ProfileStatsProps {
  reviews: object;
  projectsCompleted: number;
  // earnings: string;
  dailyRate: number;
}

export const ProfileStats = ({
  reviews,
  projectsCompleted,
  dailyRate,
}: ProfileStatsProps) => {

  const calculateAverageRating = (reviews) => {
    if (reviews?.length === 0) return 0;
    const sum = reviews?.reduce((total, review) => total + review?.rating, 0);
    return sum / reviews?.length;
  };
  const averageRating = calculateAverageRating(reviews);

  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      <div className="text-center">
        <StarFill rating={averageRating} className="mx-auto"/>  
        <div className="text-lg font-semibold">{averageRating || 0}/5</div>
        <div className="text-sm text-gray-600">Rating</div>
      </div>
      <div className="text-center">
        <Briefcase className="w-5 h-5 text-emerald-500 mx-auto mb-1" />
        <div className="text-lg font-semibold">{projectsCompleted}</div>
        <div className="text-sm text-gray-600">Projects</div>
      </div>
      {/* <div className="text-center">
        <DollarSign className="w-5 h-5 text-emerald-500 mx-auto mb-1" />
        <div className="text-lg font-semibold">{earnings}</div>
        <div className="text-sm text-gray-600">Earned</div>
      </div> */}

      <div className="text-center">
        <DollarSign className="w-5 h-5 text-emerald-500 mx-auto mb-1" />
        <span className="text-lg font-semibold">${dailyRate}/day</span>
        <p className="text-sm text-gray-600">Daily Rate</p>
      </div>
    </div>
  );
};
